// A client who starts an order, abandons it and orders again is left with two jobs for one company. The server
// retires the older one for new orders; this also hides the ones already left behind. Display only: nothing is
// changed or deleted, and a job with a file, a payment, a credit request or any progress is never hidden.

const UNSTARTED_STATUSES = ['payment_pending', 'awaiting_payment', 'order_received'];
const UNSTARTED_PROVIDER_STATUSES = [null, undefined, 'received'];

const isRetiredByServer = (job) =>
  Array.isArray(job.statusHistory) && job.statusHistory.some((entry) => entry?.status === 'superseded');

const isUnstarted = (job) =>
  UNSTARTED_STATUSES.includes(job.status)
  && UNSTARTED_PROVIDER_STATUSES.includes(job.providerStatus)
  && !job.fileName
  && job.paymentStatus !== 'paid'
  && !job.creditStatus;

const sameOrderSlot = (older, newer) =>
  older.id !== newer.id
  && Boolean(older.companyId)
  && older.companyId === newer.companyId
  && (older.financialYear || null) === (newer.financialYear || null)
  && new Date(newer.createdAt) > new Date(older.createdAt);

export function hideSupersededJobs(jobs) {
  return jobs.filter((job) => {
    if (isRetiredByServer(job)) return false;
    if (!isUnstarted(job)) return true;
    return !jobs.some((other) => sameOrderSlot(job, other) && !isRetiredByServer(other));
  });
}
